import { Flex, FlexItem } from '@patternfly/react-core';
import Setup from './Setup';
import Avatar from './Avatar';
import Notifications from './Notifications';
import React, { useState } from 'react';
import HeaderMenuItems from './HeaderMenuItems';
import { HeaderMenuItem } from '../../helpers/headerHelper';
import { useApplication, useIsGranted } from '../../components/user/ApplicationProvider';
import { Permission } from '../../enums/permission.enum';
import BuilderZoneTag from './BuilderZoneTag';
import { useMount } from 'react-use';
import { ZoneSettingEnum } from '../../api/zone/ZoneSetting';
import SiteHelpIcon from './SiteHelpIcon';

type Props = {
	menuItems: HeaderMenuItem[];
};

const HeaderContent = (props: Props) => {
	const { menuItems } = props;
	const isGranted = useIsGranted();
	const hasViewNotificationsPerm = isGranted(Permission.ViewZoneNotification);
	const hasViewSetupPerm = isGranted(Permission.CanViewSetupPage);
	const [isBuilderZone, setIsBuilderZone] = useState<boolean>(false);
	const [hasExternalHelpUrl, setHasExternalHelpUrl] = useState<boolean>(true);
	const { zoneSettings } = useApplication();

	useMount(() => {
		const builderZoneSetting = zoneSettings.find(
			(setting) => setting.zone_setting_enum_id === ZoneSettingEnum.isbuilderzone
		);

		if (builderZoneSetting) {
			if (builderZoneSetting.value.toLowerCase() == 'true') {
				setIsBuilderZone(true);
			}
		}
	});

	return (
		<Flex
			justifyContent={{ default: 'justifyContentSpaceBetween' }}
			alignItems={{ default: 'alignItemsCenter' }}
		>
			<HeaderMenuItems headerMenuItems={menuItems} />
			<FlexItem>
				<Flex>
					{isBuilderZone && (
						<FlexItem>
							<BuilderZoneTag />
						</FlexItem>
					)}
					{hasViewSetupPerm && (
						<FlexItem style={{ margin: 0 }}>
							<Setup />
						</FlexItem>
					)}
					<FlexItem
						className="helpInfoSection"
						style={{ margin: 0 }}
					>
						<SiteHelpIcon />
					</FlexItem>
					{hasViewNotificationsPerm && (
						<FlexItem style={{ margin: 0 }}>
							<Notifications />
						</FlexItem>
					)}
					<FlexItem>
						<Avatar />
					</FlexItem>
				</Flex>
			</FlexItem>
		</Flex>
	);
};

export default HeaderContent;
